export default __webpack_public_path__ + "static/media/osmankurt5.7c440bfa.jpg";